import { useState } from 'react';
import dynamic from 'next/dynamic';

import { Button, Modal } from '@/molecules';

import type { FunctionComponent } from 'react';
import type { TypeViewOldOrdersProps } from './types';

const GetOldOrders = dynamic(
  () =>
    import('@/organisms/forms/GetOldOrders').then((mod) => mod.GetOldOrders),
  {
    ssr: false,
  },
);

/**
 * ViewOldOrders
 */
export const ViewOldOrders: FunctionComponent<TypeViewOldOrdersProps> = ({
  className,
}: TypeViewOldOrdersProps) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Modal open={showModal} setOpen={setShowModal}>
        <GetOldOrders />
      </Modal>

      <Button
        {...(className && { className })}
        onClick={() => setShowModal(true)}
      >
        CONSULTAR PEDIDOS ANTERIORES
      </Button>
    </>
  );
};

ViewOldOrders.displayName = 'ViewOldOrders';
